"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = void 0;
var _react = _interopRequireWildcard(require("react"));
var _enums = require("../../constants/enums");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var TableRow = exports.TableRow = function TableRow(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayExtra = _useState2[0],
    setDisplay = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    tableRowHeight = _useState6[0],
    setTableRowHeight = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    extraTableRowHeight = _useState8[0],
    setExtraTableRowHeight = _useState8[1];
  (0, _react.useEffect)(function () {
    setDisplay(props.areAllRowsExpanded || false);
    setExpanded(props.areAllRowsExpanded ? "expanded" : "");
  }, [props.areAllRowsExpanded]);
  function displayExtraContent() {
    if (props.extraContent == null) {
      setDisplay(false);
    } else {
      setDisplay(!displayExtra);
      if (!displayExtra) {
        setExpanded("expanded");
      } else {
        setExpanded("");
      }
    }
  }
  var handleEnterPress = function handleEnterPress(event) {
    if (event.key === _enums.TargetEvent.Enter) {
      displayExtraContent();
    }
  };
  var arrowUp = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("td", {
    tabIndex: 0,
    className: "table-dropdown-container",
    onKeyPress: handleEnterPress,
    onClick: function onClick() {
      return displayExtraContent();
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "table-row-separator table-span"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "material-icons chev animate-arrow table-span",
    "aria-label": "keyboard_arrow_up"
  }, "keyboard_arrow_up")));
  var arrowDown = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("td", {
    tabIndex: 0,
    className: "table-dropdown-container",
    onKeyPress: handleEnterPress,
    onClick: function onClick() {
      return displayExtraContent();
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "table-row-separator table-span"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "material-icons chev animate-arrow selected table-span",
    "aria-label": "keyboard_arrow_down"
  }, "keyboard_arrow_up")));
  var getArrow = function getArrow(display) {
    if (display) {
      return arrowUp;
    } else {
      return arrowDown;
    }
  };
  var tableCells = props.tableCells.map(function (tableCell, i) {
    if (tableCell.cssClass === undefined) {
      tableCell.cssClass = "";
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "product-info-cell-".concat(i)
    }, tableCell.customHeight ? /*#__PURE__*/_react["default"].createElement("td", {
      className: tableCell.cssClass + " justify-content",
      style: {
        height: "".concat(tableRowHeight, "px")
      }
    }, tableCell.value) : /*#__PURE__*/_react["default"].createElement("td", {
      className: tableCell.cssClass + " justify-content"
    }, tableCell.value));
  });
  if (!props.extraContent && props.dropdownInUse) {
    tableCells.push( /*#__PURE__*/_react["default"].createElement("td", {
      className: "dropdownInUse-content",
      key: "dropdownInUse-content"
    }));
  }
  if (props.rowId) {
    var height = 47;
    var tblRw = document.getElementById("".concat(props.rowId, "-").concat(props.rowNumber));
    if (tblRw) {
      height = tblRw.offsetHeight;
    }
    (0, _react.useEffect)(function () {
      setTableRowHeight(height);
    }, [height]);
    var extraRowHeight;
    (0, _react.useEffect)(function () {
      var extraContentRw = document.getElementById("".concat(props.rowId, "-extra-content-").concat(props.rowNumber));
      if (extraContentRw) {
        extraRowHeight = extraContentRw.offsetHeight;
      }
      if (displayExtra && extraRowHeight !== extraTableRowHeight) {
        setExtraTableRowHeight(extraRowHeight);
      }
    }, [displayExtra]);
  }
  var zIndex = 1;
  if (displayExtra && props.buttonPressed) {
    var extraContentRw = document.getElementById("".concat(props.rowId, "-extra-content-").concat(props.rowNumber));
    if (extraContentRw) {
      if (extraContentRw.querySelector(".display-list") !== null) {
        zIndex = 2;
      } else {
        zIndex = 1;
      }
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("tr", {
    className: "table-row-content ".concat(expanded, " ").concat(props.rowClass),
    id: "".concat(props.rowId, "-").concat(props.rowNumber)
  }, tableCells, props.extraContent ? getArrow(displayExtra) : null), displayExtra ? /*#__PURE__*/_react["default"].createElement("tr", {
    className: "table-row-content ".concat(expanded, "-content-border")
  }, /*#__PURE__*/_react["default"].createElement("td", {
    colSpan: tableCells.length + 1
  })) : null, displayExtra ? /*#__PURE__*/_react["default"].createElement("tr", {
    className: "table-row-content ".concat(expanded, "-content"),
    style: {
      height: "".concat(extraTableRowHeight, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement("td", {
    colSpan: tableCells.length + 1,
    className: "extra-content-fix",
    id: "".concat(props.rowId, "-extra-content-").concat(props.rowNumber),
    style: {
      zIndex: "".concat(zIndex)
    }
  }, props.extraContent)) : null);
};
//# sourceMappingURL=tableRow.js.map